import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

// بعد مسح QR: مهلة 30 ثانية لالتقاط الصورة وإلا يُلغى الرمز ويُعاد المسح وفحص كل الشروط.
export const useQrExpiry = ({ open, qrCode, onExpire, ms = 30000 }) => {
  const { t } = useTranslation();
  const cb = useRef(onExpire);
  cb.current = onExpire;
  useEffect(() => {
    if (!open || !qrCode) return undefined;
    const id = setTimeout(() => {
      toast.message(t("qr.expired"));
      cb.current();
    }, ms);
    return () => clearTimeout(id);
  }, [open, qrCode, ms, t]);
};
